export default __webpack_public_path__ + "static/media/bathroom1-before-1024w.e41e6489.avif";